<script>
    export default {
        props: {
            filterItemID: Number,
            assetTypeID: Number,
            methodDelete: Function, 
        },
        computed: {
            filterItem(){return this.$store.getters.FILTER_ITEM_ID(
                this.assetTypeID,
                this.filterItemID, 
            )}
        }
    }
</script>


<template>
    <input
        type="text"
        disabled
        class="right_input"
        :value="filterItem['name']"
    >
    <button
        class="button_blue_100 ml_10"
        @click="methodDelete(filterItem['id'])"
    >Delete</button>
</template>